import common from "commons/languages/english";

const trans = {
  program_name: "DS Commerce",
  version: "1.0.2",
};

export default { ...common, ...trans };
